import { h } from '@stencil/core';
import type { ObservableMap } from '@stencil/store';

import type { MatchStoreState } from '../../../services/interfaces';

import { getMatchWording, isLiveMatchPenalties, matchLineupsAvailable } from './helpers';
import {
  isLiveMatch,
  isSizePlus,
  isUpcomingMatch,
  lineupStatus,
  matchMinute,
  setCssVariant,
} from './helpers/match-unit.helpers';

type Props = {
  state: ObservableMap<MatchStoreState>['state'];
};

const MatchUnitVerticalMiddleRight = ({ state }: Props) => {
  const size = state.size;
  const cssVariant = setCssVariant(size);
  const match = state.matchData;
  const isPlusSize = isSizePlus(size);

  const isUpcoming = isUpcomingMatch(match.status);
  const isLive = isLiveMatch(match.status);
  const isLivePenalties = isLiveMatchPenalties(match.status, match.phase);

  return (
    <div class="right" part="right">
      {isLivePenalties && !isPlusSize && (
        <span class={{ 'pk-match__status--minute': true, ...cssVariant }} part="status-minute">
          {getMatchWording('ft')}
        </span>
      )}
      {isLive && !isLivePenalties && (
        <span class={{ 'pk-match__status--minute': true, ...cssVariant }} part="status-minute">
          {matchMinute(match)}
        </span>
      )}
      {isUpcoming && matchLineupsAvailable(match) && (
        <div class={{ 'pk-match__status--lineups': true, ...cssVariant }} part="status-lineups">
          {lineupStatus(match)}
        </div>
      )}
    </div>
  );
};

export { MatchUnitVerticalMiddleRight };
